module.exports = __webpack_public_path__ + "img/logo@2x.f71b6342.png";